import { AppKind } from '@core/tellent-types';

export const readAppKindFromPath = () => {
  const path = window.location.pathname.split('/');
  const [_, appKind] = path;

  return <`${AppKind}`>appKind;
};
